import {Inject, Component, Input, Output , EventEmitter, OnDestroy} from '@angular/core';
 import { Store } from '@src/store';
import * as _ from "lodash";
import { DialogManagerService } from '@src/services';
import { projectActions } from '@src/store/reducers/projectReducer';
import { SessionService } from '@src/services';
import { jobsActions } from '@src/store/reducers/jobsReducer';
import * as _str from 'underscore.string';
//import { processesHoverViewModule } from './processesHoverView.module';

@Component({
    selector: 'processes-hover-view',
    template: require('./processesHoverView.html'),
    styles: [require('./processesHoverView.scss')]
})
export class ProcessesHoverViewComponent implements OnDestroy{
  
        @Input() projId;
        @Input() isDraft;
        @Output() onProcessUpdateReceivedData = new EventEmitter();
        @Output() updateTimer = new EventEmitter();
        @Output() setProcessConnectionStatus = new EventEmitter();
        
        public unauthorized;
        //public getKillingBtnCaption;
        //public connectionStateAddError;
        public destroyed:boolean;
        public continouesErrorCount;
        public period = 8;
        //public notAllowJobTypes;
        static tickTime:Date = new Date();
        static tempTickTime:Date = new Date();

  
        public processConnectionState;
        public connectionStatuses = {
            GOOD: "GOOD",
            BAD: "BAD",
            WARNING: "WARNING"
        };
    
        public jobPullingIntervalSpeed;
        public processesContainerNgClass;
        //public m_getJobsExecuted;
        public tickInterval;
        //public connectionStateUpdate;
        public jobPullingIntervalNormal;
        //public recentlyFinishedSelected;
        public loadingData = true
        public recentlyFinishedLoading = true;
        public runningProcesses = [];
        public pendingProcesses = [];
        public isRunning = false;
        public recentlyExecutedProcesses = [];
        public $translateJobName;
        //public updateContainerNgClass;
        //public extendedToggle;
        public publishProjectFlag = false;
        //public getPendingTabLabel;
        public timeout;
       // public finishPublishProject;
        public tempProjectId = "";
        public tempProjectName = "";
        //public outsideClickEvent;
        //public getRunningTabLabel;
        public tempProjectParentId = "";
        public proccessCount = 0
        public $translate;
        public currentProjId;
        public isShowView = false;
        //public getAveragePercentage;
        public isExpandedView = false;
    constructor(@Inject('$scope') private $scope: any,@Inject('JobsSpeedInterval') private JobsSpeedInterval: any ,@Inject('JobsNormalInterval') private JobsNormalInterval: any ,@Inject('$state') private state: any,private sessionService: SessionService,
    @Inject('processDetailsModalService') private processDetailsModalService: any , private store:Store,@Inject('statuses') private $statuses: any ,private dialogManagerService: DialogManagerService,@Inject('$filter') private $filter: any) {
        //this.getTotalProcesses = () => this.runningProcesses.length + this.pendingProcesses.length;
        // this.getActiveProcesses = () => this.runningProcesses.length;
        this.$translateJobName = this.$filter('changeEnumJobNameToName');
        this.$translate = $filter('translate');
        // this.getPendingProcesses = () => this.pendingProcesses.length;
        this.currentProjId = this.projId;
       

        this.jobPullingIntervalNormal = this.JobsNormalInterval;
        this.jobPullingIntervalSpeed = this.JobsSpeedInterval;

        ProcessesHoverViewComponent.tickTime = null;
        this.tickInterval = this.jobPullingIntervalNormal;
        this.timeout = null;

        
        this.processConnectionState = this.connectionStatuses.GOOD;
        this.continouesErrorCount = 0;


       

        //this.m_getJobsExecuting();
        this.timeoutCall();
        // this.getKillingBtnCaption = isAbort => 
        //     isAbort ? this.$translate('ABORTING_JOB') : this.$translate('ABORT_JOB')
      
}
        getTotalProcesses = () =>  this.runningProcesses.length + this.pendingProcesses.length 
        getActiveProcesses = () => this.runningProcesses.length;
        getPendingProcesses = () => this.pendingProcesses.length;
        getTotalPercentage = () => {
        //this.sessionService.Presentege()
        let presentage = this.runningProcesses.length > 0 ? this.getAveragePercentage() : this.pendingProcesses.length > 0 ? this.pendingProcesses[0].PercentageComplete : 0
        // this.sessionService.UpdatePresentage(presentage)
        this.sessionService.updatePresentage(presentage);
        return this.runningProcesses.length > 0 ? this.getAveragePercentage() : this.pendingProcesses.length > 0 ? this.pendingProcesses[0].PercentageComplete : 0;
        };
        getAveragePercentage = () => {
            let sum = 0;
            this.runningProcesses.forEach(item => sum += item.PercentageComplete)
            return (sum / this.getTotalProcesses())
        };
        getRunningTabLabel = () => " Running (" + this.getActiveProcesses() + ")";
        getPendingTabLabel = () => " Pending (" + this.getPendingProcesses() + ")";
        outsideClickEvent = () => {
            this.$scope.$apply(() => {
                this.isExpandedView = false;
                window.removeEventListener("click", this.outsideClickEvent);
                this.updateContainerNgClass()
            });
        };
        
        extendedToggle = ($event) => {
            //console.log(this.isExpandedView)
            if ($event)
                $event.stopPropagation();
            if (this.isExpandedView) {
                window.removeEventListener("click", this.outsideClickEvent);
                this.isExpandedView = false;
            } else {
                window.addEventListener("click", this.outsideClickEvent);
                this.isExpandedView = true;
            }
            this.updateContainerNgClass()
        };
        updateContainerNgClass = () => {
            this.processesContainerNgClass = ((this.isShowView ? "show-view" : "") + (this.isExpandedView ? " expand-view" : ""));
        };
        noPropagation = ($event) => {
            $event.stopPropagation();
        };
        recentlyFinishedSelected = (event) => {
            if(event.index == 2){
                 this.m_getJobsExecuted()
            }
           
        };
        recentlyFinishedDeselect = () => {
            this.m_setRecentlyFinishedLoading(true, true)
        };
        openProcessDetails = (processData) => {
            this.processDetailsModalService.OpenProcessDetailsModal(processData)
        };

        finishPublishProject = () => {
            this.publishProjectFlag = false;
            //go to configurations without draft
            this.state.go('app.authorized.environments', {
                id: this.tempProjectParentId,
                name: this.tempProjectName
            });
            //edit mode turn off
            this.store.dispatch({
                type: projectActions.SET_EDIT_MODE,
                payload: { editMode: false, isNewDraft: false }
            });
            //change the project to be without draft
            this.sessionService.set(`project_${this.tempProjectParentId}`, this.tempProjectName);
            //this.localStorageService.set(`project_${this.tempProjectParentId}`, this.tempProjectName);
            this.dialogManagerService.showSuccessDialog({ 
                title: this.$translate('SUCCESS_PROJECT_SAVE'), 
                text: '' 
            });
        }
        timeoutCall = () => {
            if (!ProcessesHoverViewComponent.tickTime)
                ProcessesHoverViewComponent.tickTime = new Date();
            let timeDif = new Date().getTime() - ProcessesHoverViewComponent.tickTime.getTime();
            if (timeDif >= this.tickInterval) {
                this.m_getJobsExecuting();
            } else {
                this.timeout = setTimeout(() => {
                    this.timeoutCall();
                }, this.tickInterval - timeDif)
            }
        };
        notAllowJobTypes = (type) => {
            let jobAllow = true;
            switch (type) {
                case "IMPORT_SCRIPTS":
                case "VER_PACKAGING":
                case "ENV_DRIFT_DETECTION":
                    jobAllow = false;
                    break;
            }
            return jobAllow;
        }
        customJobKillResponseHandling = (resp, process, actionType) => {
            let success = false;
            let modalData = null;
            actionType = actionType==='Cancel' ? actionType = 'Cancelling' : actionType = actionType + 'ing';// + 'ed';
            const { Title = "", VersionNames = "", JobQId = 0, EnvironmentNames = ""} = { ...process };
            if (resp.data && resp.data === true) {
                modalData = {
                    message: _str.sprintf(this.$translate('SUCCESS_JOB_KILL'),
                        JobQId,
                        ` ${this.$translateJobName(Title)} ${VersionNames ? ' - ' + VersionNames : ''}`,
                        EnvironmentNames, actionType),
                    text: ''
                };
                //this.m_getJobsExecuting();
                this.timeoutCall();
                success = true;
                this.dialogManagerService.showSuccessDialog({ title: modalData.message, text: modalData.text });
            } else {
                modalData = {
                    message: _str.sprintf(this.$translate('FAIL_JOB_KILL'),
                        JobQId,
                        ` ${this.$translateJobName(Title)} ${VersionNames ? ' - ' + VersionNames : ''}`,
                        EnvironmentNames,
                        actionType),
                    text: ''
                };
                this.dialogManagerService.showErrorDialog({ title: modalData.message, text: modalData.text });
            }
            return success;
        };
        killJob = (process) => {
            const onConfirm = () =>
            {
                let actionType = process.Status == 0 ? this.$translate('CANCEL_JOB') : this.$translate('ABORT_JOB');
                return this.store.dispatch({
                    type: jobsActions.KILL_JOB,
                    payload: {
                        jobQId: process.JobQId,
                        actionType: actionType
                    },
                    customErrorHandling: false,
                    silentRequest: false,
                })
                .then((resp) => 
                { 
                    return this.customJobKillResponseHandling(resp, process, actionType);
                });
            }
            const dialogData = { title: process.Status == 0 ? 'Cancel Job' : 'Abort Job', action: process.Status == 0 ? 'cancel' : 'abort' ,item: process.Title};
            this.dialogManagerService.showConfirmationDialog(dialogData, onConfirm);     
        }
        handleJobExecutingResponse = (resp) => {
            if (!this.destroyed) {
                if (this.unauthorized) {
                    clearTimeout(this.unauthorized);
                    this.unauthorized = null;
                }
                this.loadingData = false;
                // This is used in case parent component passes a function to handle update of job execution
                if (this.onProcessUpdateReceivedData != null) {
                    const process = resp.data.filter(item => {
                        return item.Status != 0 && this.notAllowJobTypes(item.Title);
                    });
                    this.onProcessUpdateReceivedData.emit({ data: process });
                    this.updateTimer.emit();
                }
                this.runningProcesses = resp.data
                .map((process) => {
                    if (process.Status === 7) { // 1 - running, 7 - aborting
                        process.killingBtnCaption = this.$translate('ABORTING_JOB');
                        process.disableAbort = true;
                    } else {
                        process.killingBtnCaption = this.$translate('ABORT_JOB');
                        process.disableAbort = false;
                    }
                    //check for upgrade with "__Rollback" and change it to Rollback Execution 
                    let isRollbackExe1 = "";
                    var isRollbackExe2 = [];
                    if(process.VersionNames)
                        isRollbackExe1= process.VersionNames.split("__")
                    
                    if(isRollbackExe1.length > 1)
                          isRollbackExe2 = isRollbackExe1[1].split("_");
                    let stageName = "";
                    if(isRollbackExe2.length > 0 && isRollbackExe2[0] === "Rollback")
                    {    
                        stageName = "Rollback Execution"
                        process.Title = stageName;
                    }

                    return process;
                })                    
                .filter((item) => {
                    return (item.Status == 1 || item.Status == 7) && this.notAllowJobTypes(item.Title);
                });
                
                this.pendingProcesses = resp.data.filter((item) => {
                    return item.Status == 0 && this.notAllowJobTypes(item.Title);
                });

                if(this.proccessCount != (this.runningProcesses.length + this.pendingProcesses.length)){
                    this.sessionService.updateActivity(true);
                } 
                this.proccessCount = (this.runningProcesses.length + this.pendingProcesses.length)
                if ((this.runningProcesses.length + this.pendingProcesses.length) > 0) {
                    this.tickInterval = this.jobPullingIntervalSpeed;
                    this.isShowView = true;
                    this.isRunning = true;
                } else {
                    this.tickInterval = this.jobPullingIntervalNormal;
                    this.isShowView = false;
                    this.isRunning = false;
                }


                
                //checks if the flag is on
                if(this.publishProjectFlag)
                {    
                    this.store.dispatch({
                        type: projectActions.GET_IS_PROJECT_EXISTS,
                        payload: { projectId: this.tempProjectId}
                    })
                    .then(response => {
                        if(!response.data && this.publishProjectFlag)
                        {
                            this.finishPublishProject();
                        }
                    })


                }
                else if( (resp.data.length !== 0 && resp.data[0].Title === "PUBLISH_PROJECT" && this.store.getState().projects && !this.publishProjectFlag))
                {
                    if(this.store.getState().projects.projectWithMetaData && this.store.getState().projects.projectWithMetaData.parentId)
                    {
                        this.publishProjectFlag = true;
                        this.tempProjectId = this.store.getState().projects.projectWithMetaData.id;
                        this.tempProjectParentId = this.store.getState().projects.projectWithMetaData.parentId;
                        this.tempProjectName = this.store.getState().projects.projectWithMetaData.name;
                    } 
                }
                else if(resp.data.length === 0 && this.store.getState().project && 
                this.store.getState().project.data && this.store.getState().project.editMode)
                {
                    this.tempProjectId = this.store.getState().project.data.id;
                    this.tempProjectParentId = this.store.getState().project.data.parentId;
                    this.tempProjectName = this.store.getState().project.data.name;

                    this.store.dispatch({
                        type: projectActions.GET_IS_PROJECT_EXISTS,
                        payload: { projectId: this.tempProjectId}
                    })
                    .then(response => {
                        if(!response.data || this.publishProjectFlag)
                        {
                            this.finishPublishProject();
                        }
                    })
                }  
                this.updateContainerNgClass();
                this.connectionStateReset();
                this.timeoutCall();
            }
        };
        handleJobExecutionError = (resp) => {
            this.loadingData = false;
            if (!this.destroyed) {
                this.connectionStateAddError();
                this.timeoutCall();
                if (!this.unauthorized && resp.status == 401) {
                    this.unauthorized = setTimeout(() => {
                        this.state.go("app.auth.login");
                    }, 30000);
                }
            }
        };
        m_getJobsExecuting = () => {
            
            const name = this.sessionService.get(`project_${this.currentProjId}`) || '';
            this.isDraft = false;
            try {
                if (name.indexOf("Draft") != -1)
                 this.isDraft = true;
            }
            catch (e) { }
            if (this.currentProjId != null && !this.store.getState().project.editMode && !this.isDraft) {
                this.store.dispatch({
                    type: jobsActions.GET_JOBS_EXECUTING_BY_PROJ,
                    payload: { projId: this.currentProjId
                    },
                    customErrorHandling: true,
                    silentRequest: true,
                }).then(this.handleJobExecutingResponse, this.handleJobExecutionError)
            }
            
            else //if(this.currentProjId === null && !this.store.getState().project.editMode && !isDraft) 
            {
                if(this.state.current.name.includes('environments') || this.state.current.name.includes('packages') || this.state.current.name.includes('configurationsView')){
                    this.store.dispatch({
                        type: jobsActions.GET_JOBS_EXECUTING,
                        customErrorHandling: true,
                        silentRequest: true,
                    }).then(this.handleJobExecutingResponse, this.handleJobExecutionError)
                }
            }
            
            ProcessesHoverViewComponent.tickTime = new Date();  
        };
        m_getJobsExecuted = () => {
            let resp = (resp) => {
                this.recentlyExecutedProcesses = resp.data;
                this.m_setRecentlyFinishedLoading(false, false)
            };
            let err = () => {
                this.m_setRecentlyFinishedLoading(false, false)
            };

            const name = this.sessionService.get(`project_${this.currentProjId}`);
            this.isDraft = false;
            try {
                if (name.indexOf("Draft") != -1)
                    this.isDraft = true;
            }
            catch (e) { }
            if (this.currentProjId != null && !this.store.getState().project.editMode && !this.isDraft) {
                this.store.dispatch({
                    type: jobsActions.GET_JOBS_EXECUTED_BY_PROJ,
                    payload: { projId: this.currentProjId, period: this.period },
                    silentRequest: true,
                }).then(resp, err)
            } else {
                this.store.dispatch({
                    type: jobsActions.GET_JOBS_EXECUTED,
                    payload: { period: this.period },
                    silentRequest: true,
                }).then(resp, err)
            }
        };

        setProjectListener = ($event, projId) => {
            $event.stopPropagation();

            this.currentProjId = projId
            this.m_getJobsExecuted();
        };

        m_setRecentlyFinishedLoading = (isLoading, withTimeOut) => {
            if (withTimeOut) {
                setTimeout(() => { this.recentlyFinishedLoading = isLoading; }, 150);
            } else {
                this.recentlyFinishedLoading = isLoading;
            }
        };
        connectionStateReset = () => {
            this.continouesErrorCount = 0;
            this.connectionStateUpdate();
        };

        connectionStateAddError = () => {
            this.continouesErrorCount++;
            this.connectionStateUpdate();
        };

        connectionStateUpdate = () => {
            if (this.continouesErrorCount > 5) {
                this.processConnectionState = this.connectionStatuses.BAD;
            } else if (this.continouesErrorCount > 0) {
                this.processConnectionState = this.connectionStatuses.WARNING;
            } else {
                this.processConnectionState = this.connectionStatuses.GOOD;
            }

            if (this.setProcessConnectionStatus != null) {
                this.setProcessConnectionStatus.emit({ data: this.processConnectionState });
            }
        };
        
        getKillingBtnCaption = isAbort => 
            isAbort ? this.$translate('ABORTING_JOB') : this.$translate('ABORT_JOB')
statusesToString(value,fieldName){
   return this.$statuses[value][fieldName]
}

    ngOnDestroy = () => {
        clearTimeout(this.timeout);
        if (this.unauthorized) {
            clearTimeout(this.unauthorized);
        }
        this.destroyed = true;
    };
    
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/pipeline/processesHoverView-ang7/processesHoverView.ts